'use client';

import { Thumbnail } from '@/app/saved/components/Thumbnail';
import type { PublicDesign } from '@/app/lib/community/shared';
import { CLIENT_ADAPTERS } from '@/app/lib/community/types';

/**
 * The large preview on a design's page, drawn by the saved library's renderer for that type — or by the
 * type's own preview (skins: front, back and the skin file), which sizes itself.
 */
export default function DesignPreview({ design }: { design: PublicDesign }) {
  const Preview = CLIENT_ADAPTERS[design.type].Preview;
  if (Preview) {
    return (
      <div className="w-full max-w-sm mx-auto rounded-xl bg-zinc-950 border border-zinc-800 p-4">
        <Preview design={design} size="modal" />
      </div>
    );
  }
  return (
    <div className="aspect-[4/5] w-full max-w-sm mx-auto rounded-xl bg-zinc-950 border border-zinc-800 overflow-hidden">
      <Thumbnail item={CLIENT_ADAPTERS[design.type].toLibraryItem(design)} size="modal" />
    </div>
  );
}
